import { render, staticRenderFns } from "./TrueRepair.vue?vue&type=template&id=24577890&scoped=true&"
import script from "./TrueRepair.vue?vue&type=script&lang=ts&"
export * from "./TrueRepair.vue?vue&type=script&lang=ts&"
import style0 from "./TrueRepair.vue?vue&type=style&index=0&id=24577890&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24577890",
  null
  
)

export default component.exports